/* eslint-disable react/prop-types */
/* level and children in our components are incorrectly inferred by eslint as props of <Markdown> */

import React from "react"
import ReactMarkdown from "react-markdown"
import clsx from "classnames"

// Adapted from:
// https://github.com/mui-org/material-ui/blob/master/docs/src/pages/getting-started/templates/blog/Markdown.js

const Header = ({ level, children }) => {
  const HeaderVariant = `h${level}`

  // return <Typography variant={headerVariant}>{children}</Typography>

  return (
    <HeaderVariant
      className={clsx("my-4 font-bold", {
        "text-2xl": level === 1,
        "text-xl": level === 2,
        "text-lg": level === 3,
        "text-base": level === 4,
        "text-sm": level === 5,
        "text-xs": level === 6,
      })}
    >
      {children}
    </HeaderVariant>
  )
}

const components = {
  h1: (props) => <Header {...props} />,
  h2: (props) => <Header {...props} />,
  h3: (props) => <Header {...props} />,
  h4: (props) => <Header {...props} />,
  h5: (props) => <Header {...props} />,
  h6: (props) => <Header {...props} />,

  p: ({ children }) => <p className="text-sm">{children}</p>,
}

export default function Markdown(props) {
  return <ReactMarkdown components={components} {...props} />
}
